import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";
import {html} from "lit";
import {CustomerRepository} from "../../crm/CustomerRepository.js";
import {TimeTool} from "../../lib/TimeTool.js";
import {NO_CUSTOMER_ID} from "../TimesheetEntry.js";
import {Customer} from "../../crm/Customer.js";
import {HTML} from "../../lib/HTML.js";
import {TimesheetReportTool} from "../TimesheetReportTool.js";

export class WeeklyTimePerCustomerWidget extends ResolvingLitElement {

    static properties = {
        dayInWeek: {type: String, reflect: true},
        _byWeekDayStat: {type: Map},
    }

    /**
     * @private {ReactiveArray<TimesheetEntry>}
     */
    _entries;

    /**
     * @private {CustomerRepository}
     */
    _customerRepo;

    /**
     *
     * @protected {TimesheetReportTool}
     */
    _reportTool;

    constructor() {
        super();
        this.dayInWeek = TimeTool.dayAsString();

        this._reportTool = new TimesheetReportTool();

        /** @type {Map<string,{customer:Customer,billable:number,notBillable:number}>} **/
        this._byCustomerStat = new Map();

        /** @type {Map<number, {weekDay:string,billable:number,notBillable:number,perCustomer:Map<string,{customer:Customer,billable:number,notBillable:number}>}>} **/
        this._byWeekDayStat = new Map();

        this._billableHourColor = HTML.cssVariable('billable-color');
        this._unBillableHourColor = HTML.cssVariable('not-billable-color');
    }

    render() {
        return html`
            <div class="card weekly-time-summary">
                <header>
                    <h4>Week by customer</h4>
                </header>
                <table class="striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Mo</th>
                            <th>Tu</th>
                            <th>We</th>
                            <th>Th</th>
                            <th>Fr</th>
                            <th>Sa</th>
                            <th>Su</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                    ${Array.from(this._byCustomerStat.values()).map( (item, key) => { 
                        return html`<tr>
                            <th title="${item.customer.name}">${item.customer.folderName ? item.customer.folderName : item.customer.name}</th>
                            <td>${this._getDailyTotalOfCustomer(1, item.customer.id)}</td>
                            <td>${this._getDailyTotalOfCustomer(2, item.customer.id)}</td>
                            <td>${this._getDailyTotalOfCustomer(3, item.customer.id)}</td>
                            <td>${this._getDailyTotalOfCustomer(4, item.customer.id)}</td>
                            <td>${this._getDailyTotalOfCustomer(5, item.customer.id)}</td>
                            <td>${this._getDailyTotalOfCustomer(6, item.customer.id)}</td>
                            <td>${this._getDailyTotalOfCustomer(7, item.customer.id)}</td>
                            <td>${this._getWeeklyTotalOfCustomer(item.customer.id)}</td>
                        </tr>`
                    })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th></th>
                            <td>${this._getDailyTotal(1)}</td>
                            <td>${this._getDailyTotal(2)}</td>
                            <td>${this._getDailyTotal(3)}</td>
                            <td>${this._getDailyTotal(4)}</td>
                            <td>${this._getDailyTotal(5)}</td>
                            <td>${this._getDailyTotal(6)}</td>
                            <td>${this._getDailyTotal(7)}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        `;
    }

    connectedCallback() {
        super.connectedCallback();
        this._entries = this._get('timesheet-entries');
        this._customerRepo = this._resolve(CustomerRepository);

    }

    disconnectedCallback() {
        super.disconnectedCallback();
        try {
            this._entries.filled.remove(this._updateWidgetData);
        } catch (e) {
            //
        }

    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this._entries.filled.listen(this._updateWidgetData);
    }

    createRenderRoot() {
        return this;
    }

    _getDailyTotal(day) {
        let stat = this._byWeekDayStat.get(day);
        if (!stat || (!stat.notBillable && !stat.billable)) {
            return '';
        }
        return this._formatBillStat(stat);
    }

    _getDailyTotalOfCustomer(day, customerId) {
        let stat = this._byWeekDayStat.get(day).perCustomer.get(customerId);
        if (!stat || (!stat.notBillable && !stat.billable)) {
            return '';
        }
        return this._formatBillStat(stat);
    }

    _getWeeklyTotalOfCustomer(customerId) {
        let stat = this._byCustomerStat.get(customerId);
        if (!stat || (!stat.notBillable && !stat.billable)) {
            return '';
        }
        return this._formatBillStat(stat);
    }

    /**
     * @param {{billable: number, notBillable: number}} stat
     * @return {TemplateResult<1>|*}
     * @private
     */
    _formatBillStat(stat) {
        let spans = [];
        if (stat.billable && stat.billable >= 60) {
            spans.push(html`<span style="color: ${this._billableHourColor}">${TimeTool.formatDurationFromSeconds(stat.billable, false)}</span>`);
        }
        if (stat.notBillable && stat.notBillable >= 60) {
            spans.push(html`<span style="color: ${this._unBillableHourColor}">${TimeTool.formatDurationFromSeconds(stat.notBillable, false)}</span>`);
        }
        return spans.length > 1 ? html`${spans[0]} ${spans[1]}` : spans[0];
    }

    _updateWidgetData = () => {

        const stats = this._reportTool.createWeeklyReport(new Date(this.dayInWeek),this._entries.items(), [])

        this._byWeekDayStat = stats.durationMap;
        this._byCustomerStat = stats.byCustomerMap;

    }

}

customElements.define('x-weekly-time-per-customer-widget', WeeklyTimePerCustomerWidget);